import { z } from "zod";

export const ApprovalPolicyRule = z
  .object({
    name: z.string().trim().min(1).max(80),
    effect: z.enum(["always_allow", "require_approval", "deny"]),
    matchKind: z.enum(["tool", "connector", "site"]),
    matchValue: z
      .string()
      .trim()
      .min(1)
      .max(253)
      .transform((v) => v.toLowerCase()),
  })
  .strict();
export const ApprovalPolicyDraft = z
  .object({
    name: z.string().trim().min(1).max(80),
    mode: z.enum(["ask", "auto"]),
    rules: z.array(ApprovalPolicyRule).max(100),
  })
  .strict();
const ApprovalPolicyBase = ApprovalPolicyDraft.extend({
  id: z.string(),
  revision: z.number().int().positive(),
  enabled: z.boolean(),
  updatedAt: z.string(),
});
export const ApprovalPolicy = ApprovalPolicyBase.extend({
  inherited: z.array(ApprovalPolicyBase).max(32).optional(),
});
export const ApprovalPolicySave = ApprovalPolicyDraft.extend({
  id: z.string().min(1).optional(),
  revision: z.number().int().positive().optional(),
}).refine(
  (v) => Boolean(v.id) === Boolean(v.revision),
  "Supply the policy ID and revision together",
);
export const ApprovalPolicyTarget = z
  .object({ id: z.string().min(1), revision: z.number().int().positive() })
  .strict();
export const ApprovalPolicyToggle = ApprovalPolicyTarget.extend({ enabled: z.boolean() });
export const ApprovalPolicyList = z.object({
  canManage: z.boolean(),
  policies: z.array(ApprovalPolicy),
});
export type SpaceApprovalPolicy = z.infer<typeof ApprovalPolicy>;
